import { useContext } from 'react';
import { StoreContext } from '../StoreProvider';

const useVideoEvents = () => {
    const { setVideoPaused, setPlayer, setVideoEnded, setVideoTime, setSeconds } = useContext(StoreContext);

    const onVideoReady = (player) => {
        setPlayer(player);
    };

    const onVideoPlay = (duration) => {
        setVideoPaused(false);
        setVideoEnded(false);
        setVideoTime(duration);
    }

    const onVideoPause = () => {
        const scrubbing = document.querySelector('.vjs-scrubbing');
        if (scrubbing) {
            return;
        }
        setVideoPaused(true);
    }

    const onVideoTimeUpdate = (duration) => {
        setVideoTime(duration);
        setSeconds(Math.round(duration));
    }

    const onVideoEnd = () => {
        setVideoPaused(false);
        setVideoEnded(true);
    }

    return {
        onVideoReady,
        onVideoPlay,
        onVideoPause,
        onVideoTimeUpdate,
        onVideoEnd,
    }
}

export default useVideoEvents;
